(async () => {
  const { showElement, hideElement } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('announcement-bar', class extends baseComponent.default {
    elements = {
      buttonClose: '[data-dismiss]',
      track: '.\\#announcement-bar-track',
      slides: '*.\\#announcement-bar-slide',
    }

    render() {
      if (this.hasAttribute('dismissible')) {
        this._useDismiss();
      }

      if (this.hasAttribute('data-rotate')) {
        this._useRotation();
      }
    }

    _useDismiss() {
      this.$buttonClose.addEventListener('click', this._closeBar.bind(this), { once: true });
      const isHidden = window.sessionStorage.getItem('hideAnnouncement');
      if (!isHidden) showElement(this);
    }

    _closeBar() {
      window.sessionStorage.setItem('hideAnnouncement', 'true');
      hideElement(this);
      this._stopRotation();
    }

    _useRotation() {
      this._currentIndex = 0;
      this._count = parseInt(this.dataset.count, 10);
      this._duration = parseInt(this.dataset.duration, 10) * 1000;
      this._transitionMs = parseInt(this.dataset.transition, 10);

      // Clone first slide and append for seamless wrap-around
      const firstSlide = this.$slides[0];
      const clone = firstSlide.cloneNode(true);
      clone.removeAttribute('id');
      clone.dataset.clone = 'true';
      this.$track.appendChild(clone);

      this.addEventListener('mouseenter', () => this._stopRotation());
      this.addEventListener('mouseleave', () => this._startRotation());

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          this._stopRotation();
          const index = parseInt(e.target.dataset.index, 10);
          this.$track.style.transform = `translateX(-${index * 100}%)`;
          this._currentIndex = index;
          this._syncDismissColor();
        });
        this.addEventListener('shopify:block:deselect', () => {
          this._startRotation();
        });
      }

      this._startRotation();
    }

    _startRotation() {
      if (this._count <= 1) return;
      this._stopRotation();
      this._intervalId = setInterval(() => this._advance(), this._duration);
    }

    _stopRotation() {
      if (this._intervalId) {
        clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }

    _advance() {
      this._currentIndex++;

      if (this._currentIndex <= this._count) {
        // Normal advance (includes scrolling to the clone at position _count)
        this.$track.style.transform = `translateX(-${this._currentIndex * 100}%)`;
      }

      if (this._currentIndex === this._count) {
        // We just scrolled to the clone of slide 0 — after the transition
        // completes, snap back to the real slide 0 with no transition
        setTimeout(() => {
          this.$track.style.transition = 'none';
          this.$track.style.transform = 'translateX(0%)';
          // Force reflow so the instant jump applies before re-enabling transition
          this.$track.offsetHeight;
          this.$track.style.transition = '';
          this._currentIndex = 0;
        }, this._transitionMs);
      }

      this._syncDismissColor();
    }

    _syncDismissColor() {
      if (!this.$buttonClose || !this.$slides?.length) return;
      const index = this._currentIndex >= this._count ? 0 : this._currentIndex;
      const slide = this.$slides[index];
      const color = getComputedStyle(slide).getPropertyValue('--announcement-bar-color-text');
      if (color) this.$buttonClose.style.color = color;
    }

    disconnectedCallback() {
      this._stopRotation();
    }
  });
})();
